import { Amplify, Auth as amplifyAuth } from 'aws-amplify'
import axios from 'axios'
import config from 'config'
import React, { useCallback, useEffect, useState } from 'react'

import logger from '../logger'

import axiosHook from './axiosHook'

export const AuthContext = React.createContext('auth')

export const ROLE_SUPER_ADMIN = 'superAdmin'
export const ROLE_ADMIN = 'admin'
export const ROLE_PARTNER_ADMIN = 'partnerAdmin'
export const ROLE_READ_ONLY = 'readOnly'
export const ROLE_PARTNER_READ_ONLY = 'partnerReadOnly'
export const ROLE_BLIND_PUBLICATION = 'blindPublication'
export const ROLE_LOGISTICS = 'logistics'
export const ROLE_B2C = 'b2c'
export const ROLE_POST_SALES = 'postSales'
// REL-F07 — ruolo lato Arval (nel BE è incluso in arvalRoles): monitor
// read-only della lifecycle Release. Volutamente NON inserito in ROLES_ARVAL:
// nell'inventario è trattato come read-only "minima" (nessuna azione, nessuna
// colonna Partner/report) e non deve sbloccare le altre pagine arval-only.
export const ROLE_TEAM_RELEASE = 'teamRelease'

export const ROLES_ARVAL = [
  ROLE_SUPER_ADMIN,
  ROLE_ADMIN,
  ROLE_READ_ONLY,
  ROLE_LOGISTICS,
  ROLE_B2C,
  ROLE_POST_SALES,
]
export const ROLES_PARTNER = [
  ROLE_PARTNER_ADMIN,
  ROLE_PARTNER_READ_ONLY,
  ROLE_BLIND_PUBLICATION,
]

Amplify.configure(config.auth)

export const AuthContextProvider = ({ children }) => {
  const [authEvent, setAuthEvent] = useState()
  const [currentSession, setSession] = useState()
  const [claims, setClaims] = useState()

  useEffect(() => {
    const run = async () => {
      updateAuth()
    }
    run()
  }, [setAuthEvent])

  const signOut = () => {
    amplifyAuth.signOut()
    setTimeout(() => {
      setAuthEvent()
      setSession()
    }, 100)
  }

  useEffect(() => {
    axios.interceptors.request.use(axiosHook(signOut))
  }, [])

  const updateAuth = async () => {
    try {
      const auth = await amplifyAuth.currentAuthenticatedUser()

      const session = await amplifyAuth.currentSession()

      const claims = JSON.parse(
        session?.idToken?.payload[config.auth.claims] || '{}'
      )

      setClaims(claims)
      setAuthEvent(auth)
      setSession(session)

      return {
        auth,
        session,
        claims,
      }
    } catch (e) {
      logger.error(e)
      setAuthEvent(null)
    }
  }

  const getAccessToken = useCallback(async () => {
    return (await amplifyAuth.currentSession())?.idToken.jwtToken
  }, [])

  return (
    <AuthContext.Provider
      value={{
        setAuthEvent,
        authEvent,
        claims,
        currentSession,
        updateAuth,
        AmplifyAuth: amplifyAuth,
        signOut,
        getAccessToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
